(function(){
    'use strict';
    angular.module('mso.registration').controller('RegisterCompleteExpiredCtrl', RegisterCompleteExpiredCtrl);

    RegisterCompleteExpiredCtrl.$inject = ['referenceData'];
    function RegisterCompleteExpiredCtrl(referenceData){
        var vm = this;

        // Initialise vm variables
        vm.messages = referenceData.messages;
        vm.parameters = referenceData.parameters;
        vm.referenceData = referenceData;
        vm.title = 'Token Expired';
        vm.vs = referenceData.valuesets;
    }
})();